// extracted by mini-css-extract-plugin
export default {"textBox":"Email_textBox__0iiv4","textInput":"Email_textInput__rST6l","Text":"Email_Text__E-XBu","textArea":"Email_textArea__w44pK"};